const url = (path: string, params: Record<string, string | number> = {}): string => {
  let full = path.startsWith('/') ? path : `/${path}`;
  Object.entries(params).forEach(([k, v]) => {
    full = full.replace(`:${k}`, String(v));
  });
  return full;
};

export const URL_LOGIN                  = url('/login');
export const URL_SIGNUP                 = url('/auth/signup');
export const URL_VERIFY_EMAIL           = url('/auth/verify-email');
export const URL_RESEND_VERIFICATION    = url('/auth/resend-verification');
export const URL_RESEND_INVITE          = url('/auth/resend-invite');
export const URL_REQUEST_RESET          = url('/request-reset');
export const URL_RESET_PASSWORD         = url('/reset-password');
export const URL_TOKEN_EMAIL            = url('/token-email');
export const URL_VERIFY_2FA_SETUP       = url('/verify-2fa-setup');
export const URL_VERIFY_PASSWORD        = url('/verify-password'); 
export const URL_ACCEPT_TOS             = url('/users/me/accept-tos');
export const URL_TERMS_ACCEPT           = url('/terms/accept');
export const URL_SESSION_HEARTBEAT      = url('/session/heartbeat');
export const URL_SESSION_END            = url('/session/end');
export const URL_AUTH_LOGOUT            = url('/auth/logout');
export const URL_GET_USER               = (token: string) => `${url('/get-user')}?token=${encodeURIComponent(token || '')}`;

export const URL_ADMIN_IMPERSONATE      = url('/admin/impersonate');
export const URL_ADMIN_IMPERSONATE_EXIT = url('/admin/impersonate/exit');

export const URL_USERS                  = url('/users');
export const URL_USERS_LIST             = url('/users/list');
export const URL_USERS_PROFILE          = url('/users/profile');
export const URL_USERS_SIGNATURE        = url('/users/signature');
export const URL_USERS_INVITE           = url('/users/invite');
export const URL_USERS_ACCEPT_INVITE    = url('/users/accept-invite');
export const URL_USERS_INVITE_INFO      = (token: string) => `${url('/users/invite-info')}?token=${encodeURIComponent(token)}`;
export const URL_USERS_REQUEST_PASSWORD_OTP   = url('/users/request-password-otp');
export const URL_USERS_CHANGE_PASSWORD_OTP    = url('/users/change-password-with-otp');

export const URL_USER_BY_ID             = (userId: string) => url('/users/:userId', { userId });
export const URL_USER_RESEND_INVITE     = (userId: string) => url('/users/resend-invite/:userId', { userId });
export const URL_USERS_PRORATED_AMOUNT  = (orgId: string, count: number) =>
  `${url('/users/orgs/:orgId/prorated-amount', { orgId })}?count=${count}`;
export const URL_PERSONAL_DETAILS       = (orgId: string) => url('/personal-details/:orgId', { orgId });
export const URL_ORG_USERS             = (orgIds: string) => `${url('/organisations/users')}?orgIds=${orgIds}`;

export const URL_ORGANISATIONS          = url('/organisations');
export const URL_ORGANISATIONS_LIST     = url('/organisations/list');
export const URL_INFO_APP_CONFIG        = url('/info/app-config');
export const URL_ENVIRONMENT            = url('/environment');
export const URL_APPS_LIST              = url('/apps/list');

export const URL_ORGANISATION_BY_ID     = (orgId: string) => url('/organisations/:orgId', { orgId });
export const URL_ORG_STORAGE_PROVIDER   = (orgId: string) => url('/organisations/:orgId/storage-provider', { orgId });
export const URL_ORGANISATION_PROFILE   = (orgId: string) => url('/organisations/:orgId/profile', { orgId });
export const URL_ORGANISATION_LOGO      = (orgId: string) => url('/organisations/:orgId/logo', { orgId });
export const URL_AGENT_MODEL_OPTIONS    = url('/organisations/agent-model-options');
export const URL_AGENT_MODEL_CATALOGUE = url('/organisations/agent-model-catalogue');
export const URL_AGENT_MODEL_PROVIDER  = (provider: string) => url('/organisations/agent-model-catalogue/:provider', { provider });
export const URL_AGENT_MODEL_SETTINGS   = (orgId: string) => url('/organisations/:orgId/agent-model-settings', { orgId });

export const URL_CLIENTS                = url('/clients');
export const URL_CLIENTS_MENTIONABLE    = url('/clients/mentionable');
export const URL_CLIENTS_MENTIONABLE_SEARCH = (q?: string, limit?: number) => {
  const params = [q ? `q=${encodeURIComponent(q)}` : '', limit ? `limit=${limit}` : ''].filter(Boolean).join('&');
  return params ? `${url('/clients/mentionable')}?${params}` : url('/clients/mentionable');
};
export const URL_CLIENTS_BY_ORG        = (orgId: string) => `${url('/clients')}?orgId=${orgId}`;
export const URL_CONTACTS_LOOKUP        = (email: string) => `${url('/contacts/lookup')}?email=${encodeURIComponent(email)}`;
export const URL_CONTACTS_BY_CLIENT     = (clientId: string) => `${url('/contacts-by-client')}?clientId=${clientId}`;
export const URL_CONTACTS_LIST_BY_ORG   = (orgId: string) => `${url('/list')}?orgId=${orgId}`;
export const URL_MEETING_CLIENTS        = url('/meeting_clients');
export const URL_CHECK_DUPLICATES       = url('/check-duplicates');
export const URL_CONTACT_ADD            = url('/add');
export const URL_CONTACT_IMPORT_DRY_RUN = url('/contact-import/import/dry-run');
export const URL_CONTACT_IMPORT         = url('/contact-import/import');

export const URL_CLIENT_BY_ID           = (clientId: string) => url('/clients/:clientId', { clientId });
export const URL_CLIENTS_BY_CONTACT    = (contactId: string) => `${url('/clients-by-contact')}?contactId=${contactId}`;
export const URL_CLIENT_ADVISERS        = (clientId: string) => url('/clients/:clientId/advisers', { clientId });
export const URL_CLIENT_ADVISER         = (clientId: string, userId: string) => url('/clients/:clientId/advisers/:userId', { clientId, userId });
export const URL_CONTACT_BY_ID          = (contactId: string) => url('/contacts/:contactId', { contactId });
export const URL_CONTACT_DELETE_BY_ID   = (contactId: string) => url('/delete/:contactId', { contactId });
export const URL_CONTACT_UPDATE_BY_ID   = (contactId: string) => url('/update/:contactId', { contactId });
export const URL_CONTACT_MERGE          = (contactId: string) => url('/:contactId/merge', { contactId });
export const URL_MEETING_CLIENT_BY_ID   = (clientId: string) => url('/meeting_clients/:clientId', { clientId });
export const URL_CONTACTS_LIST          = url('/list');

export const URL_DOCUMENTS              = url('/documents');
export const URL_DOCUMENTS_FILTERED     = (kind: string, refId: string) =>
  `${url('/documents')}?kind=${encodeURIComponent(kind)}&refId=${encodeURIComponent(refId)}`;
export const URL_DOCUMENT_BY_ID         = (id: string) => url('/documents/:id', { id });
export const URL_DOCUMENT_EXPORT_PDF    = (id: string) => url('/documents/:id/export-pdf', { id });
export const URL_DOCUMENT_LOCK          = (id: string) => url('/documents/:id/lock', { id });
export const URL_DOCUMENT_UPLOAD_IMAGE  = url('/documents/upload-image');
export const URL_DOCUMENT_FILE          = (id: string) => url('/documents/:id/file', { id });
export const URL_PLACEHOLDER_CATALOG    = url('/documents/placeholder-catalog');
export const URL_DOCUMENT_FIELDS        = (id: string) => url('/documents/:id/fields', { id });
export const URL_DOCUMENT_FIELDS_PREVIEW = (id: string) =>
  url('/documents/:id/fields/preview', { id });
export const URL_DOCUMENT_FIELDS_REBIND  = (id: string) =>
  url('/documents/:id/fields/rebind', { id });

export const URL_DOCUMENT_TEMPLATES     = url('/document-templates');
export const URL_DOCUMENT_TEMPLATE_UPLOAD = url('/document-templates/upload');
export const URL_DOCUMENT_TEMPLATE_BY_ID = (id: string) =>
  `${url('/document-templates')}/${encodeURIComponent(id)}`;
export const URL_DOCUMENT_TEMPLATE_FILE = (id: string) =>
  `${url('/document-templates')}/${encodeURIComponent(id)}/file`;

export const URL_DOCUMENT_VERSIONS      = (kind: string, refId: string) =>
  `${url('/document-versions')}?kind=${encodeURIComponent(kind)}&refId=${encodeURIComponent(refId)}`;
export const URL_DOCUMENT_VERSION_RESTORE = (id: string) =>
  url('/document-versions/:id/restore', { id });

export const URL_WIKI_PAGES              = url('/wiki');
export const URL_WIKI_SEARCH             = url('/wiki/search');
export const URL_WIKI_PAGE_BY_ID         = (id: string) => url('/wiki/:id', { id });
export const URL_WIKI_PAGE_LOCK          = (id: string) => url('/wiki/:id/lock', { id });
export const URL_WIKI_UPLOAD_IMAGE       = url('/wiki/upload-image');
export const URL_WIKI_UPLOAD_VIDEO       = url('/wiki/upload-video');
export const URL_WIKI_VIDEO_SIGNED_URL   = url('/wiki/video-signed-url');
export const URL_WIKI_REORDER            = url('/wiki/reorder');

export const URL_RELATIONSHIPS          = url('/relationships');
export const URL_RELATIONSHIPS_UPDATE   = url('/relationships/update');
export const URL_RELATIONSHIPS_UNLINK   = url('/relationships/unlink');

export const URL_RELATIONSHIP_BY_ID     = (relationshipId: string) => url('/relationships/:relationshipId', { relationshipId });
export const URL_RELATIONSHIPS_BY_CLIENT = (clientId: string) => url('/relationships/:clientId', { clientId });

export const URL_MEETINGS               = url('/meetings');
export const URL_MEETINGS_BY_ORG        = (orgId: string, advisorId?: string) =>
  `${url('/meetings')}?orgId=${orgId}${advisorId ? `&advisor=${advisorId}` : ''}`;
export const URL_MEETINGS_BY_CLIENT     = (clientId: string) =>
  `${url('/meetings')}?clientId=${encodeURIComponent(clientId)}`;
export const URL_MEETINGS_NEW           = url('/meetings/new-meetings');
export const URL_MEETINGS_NOTIFICATIONS = url('/meetings/notifications');
export const URL_MEETINGS_NOTIFICATIONS_MARK_ALL_SEEN  = url('/meetings/notifications/mark-all-seen');
export const URL_MEETINGS_NOTIFICATIONS_MARK_ALL_READ  = url('/meetings/notifications/mark-all-read');
export const URL_MEETINGS_NOTIFICATIONS_MARK_ONE_READ  = url('/meetings/notifications/mark-one-read');
export const URL_MEETINGS_POLL_MISSING_TRANSCRIPT      = url('/meetings/transcripts/poll-missing-transcription');
export const URL_MEETINGS_REDO_LIVE_TRANSCRIPT         = url('/meetings/transcripts/redo-live-transcription');
export const URL_MEETINGS_SAVE_LIVE_TRANSCRIPT         = url('/meetings/transcripts/save-live-transcript');
export const URL_MEETINGS_UPDATE_SPEAKERS              = url('/meetings/update-speakers');
export const URL_MEETINGS_UPDATE_FILE_NOTE             = url('/meetings/update-file-note');
export const URL_MEETINGS_UPDATE_FILE_NOTE_TIMESTAMP   = url('/meetings/update-file-note-timestamp');
export const URL_MEETINGS_DELETE_RECORDING             = url('/meetings/delete-recording');
export const URL_MEETINGS_RENAME_RECORDING             = url('/meetings/rename-recording');
export const URL_MEETINGS_SUMMARIZE                    = url('/meetings/summarize');
export const URL_MEETINGS_GENERATE_FILE_NOTE            = url('/meetings/generate-file-note');
export const URL_MEETINGS_SEND_EMAIL                   = url('/meetings/send-email');
export const URL_MEETINGS_TRANSCRIBE_DATA              = url('/meetings/transcribe-data');
export const URL_MEETINGS_CALENDLY_EVENT_TYPES         = url('/meetings/calendly/event-types');
export const URL_MEETINGS_CALENDLY_SEND_INVITE         = url('/meetings/calendly/send-invite');
export const URL_MEETINGS_SETTINGS                     = url('/meetings-settings');

export const URL_MEETING_BY_ID          = (meetingId: string) => url('/meetings/:meetingId', { meetingId });
export const URL_MEETING_UPDATE         = (meetingId: string) => url('/meetings/update/:meetingId', { meetingId });
export const URL_MEETING_FILE_NOTE_TEMPLATE = (meetingId: string) => url('/meetings/:meetingId/file-note-template', { meetingId });
export const URL_MEETING_ATTENDEES      = (meetingId: string) => url('/meetings/get-attendees/:meetingId', { meetingId });
export const URL_MEETING_FILE_NOTE      = (meetingId: string) => url('/meetings/get-file-note/:meetingId', { meetingId });
export const URL_MEETING_RECORDINGS     = (meetingId: string) => url('/meetings/recordings/:meetingId', { meetingId });
export const URL_MEETING_RECORDINGS_REARRANGE = (meetingId: string) => url('/meetings/recordings/:meetingId/rearrange', { meetingId });
export const URL_MEETING_UPLOAD_RECORDING     = (recordingId: string) => url('/meetings/upload-recording/:recordingId', { recordingId });
export const URL_MEETING_REQUEST_UPLOAD_URL   = url('/meetings/upload-recording/request-upload-url');
export const URL_MEETING_CONFIRM_UPLOAD       = url('/meetings/upload-recording/confirm');
export const URL_MEETING_TRANSCRIPTS_BY_CLIENT = (clientId: string) => url('/meetings/transcripts/:clientId', { clientId });
export const URL_MEETING_ATLAS_TRANSCRIPTS     = (clientId: string) => url('/meetings/atlas-transcripts/:clientId', { clientId });
export const URL_MEETING_CHUNK          = (chunkId: string) => url('/meetings/chunks/:chunkId', { chunkId });
export const URL_MEETING_CLIENT_SUMMARY = (clientId: string) => url('/meetings/client-summary/:clientId', { clientId });
export const URL_MEETING_LAST_INTERACTION = (clientId: string) => url('/meetings/last-interaction/:clientId', { clientId });
export const URL_MEETINGS_CLIENT_MEETINGS = (clientId: string) => `${url('/meetings/client-meetings')}?clientId=${clientId}`;
export const URL_MEETINGS_SETTINGS_BY_ID = (settingsId: string) => url('/meetings-settings/:settingsId', { settingsId });
export const URL_MEETINGS_NOTIFICATIONS_PAGED = (page: number, limit: number) =>
  `${url('/meetings/notifications')}?page=${page}&limit=${limit}`;
export const URL_MEETINGS_ZOOM_STATUS   = (orgId: string) => url('/meetings/status/zoom/:orgId', { orgId });
/** Calendar meetings matched to a client's linked contacts, not yet linked to Prospo */
export const URL_MEETINGS_DISCOVERED    = (clientId: string) => `${url('/meetings/discovered')}?clientId=${encodeURIComponent(clientId)}`;
export const URL_MEETINGS_EVENTS        = (timezone: string) => `${url('/meetings/events')}?timezone=${encodeURIComponent(timezone)}`;
/** Calendar events across an explicit window — used by the home calendar view. */
export const URL_MEETINGS_EVENTS_RANGE  = (timezone: string, start: string, end: string) =>
  `${url('/meetings/events')}?timezone=${encodeURIComponent(timezone)}&start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
/** Meetings scheduled directly in Zoom that never reached a calendar */
export const URL_MEETINGS_ZOOM_DISCOVERED = (start: string, end: string) =>
  `${url('/meetings/zoom-discovered')}?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
/** Auto-import 1-1s with known clients; classifies the rest for the calendar */
export const URL_MEETINGS_CALENDAR_AUTO_IMPORT = url('/meetings/calendar/auto-import');
/** Create contact + client then import, for a 1-1 with someone new */
export const URL_MEETINGS_CALENDAR_ONBOARD_IMPORT = url('/meetings/calendar/onboard-and-import');

export const URL_MEETINGS_INITIATE_TRANSCRIPTION    = url('/meetings/transcripts/initiate-transcription');
export const URL_MEETINGS_HANDLE_TRANSCRIPT_GRAPH   = url('/meetings/handle-transcript-graph');
export const URL_MEETING_TRANSCRIPT_BY_ID           = (transcriptionId: string) => url('/meetings/transcripts/:transcriptionId', { transcriptionId });
export const URL_MEETINGS_JOB_STATUS                = (jobId: string) => url('/meetings/get_job_status/:jobId', { jobId });
export const URL_MEETING_FILE_NOTE_BY_ID            = (transcriptionId: string) => url('/meetings/file-note-by-id/:transcriptionId', { transcriptionId });
export const URL_MEETING_DELETE_FILE_NOTE           = (fileNoteId: string) => url('/meetings/delete-file-note/:fileNoteId', { fileNoteId });
export const URL_MEETING_SUMMARY                    = (meetingId: string) => url('/meetings/:meetingId/summary', { meetingId });
export const URL_MEETING_SUMMARY_GENERATE           = (meetingId: string) => url('/meetings/:meetingId/summary/generate', { meetingId });
export const URL_MEETING_SUMMARY_EXPORT_PDF         = (meetingId: string) => url('/meetings/:meetingId/summary/export-pdf', { meetingId });
export const URL_MEETING_TRANSCRIPT_EXPORT_PDF      = (meetingId: string, transcriptId: string) => url('/meetings/:meetingId/transcripts/:transcriptId/export-pdf', { meetingId, transcriptId });
export const URL_MEETING_FILE_NOTE_EXPORT_PDF       = (meetingId: string, fileNoteId: string) => url('/meetings/:meetingId/file-notes/:fileNoteId/export-pdf', { meetingId, fileNoteId });

export const URL_UPLOAD                 = url('/upload');
export const URL_DRIVE                  = url('/drive');
export const URL_DRIVE_CREATE           = url('/drive/create');
export const URL_DRIVE_ROOT             = url('/drive/root');
export const URL_DRIVE_ORG_TRUE_ROOT    = url('/drive/org/true-root');
export const URL_FILES_DUPLICATE        = url('/files/duplicate');
export const URL_FOLDER                 = url('/folder');
export const URL_FOLDER_LIST            = (orgId: string) => `${url('/folder/list')}?orgId=${encodeURIComponent(orgId)}`;
export const URL_FILESHARE              = url('/fileshare');
export const URL_FILESHARE_LIST         = url('/fileshare/filesList');
export const URL_FILE_TYPES             = url('/file-types');
export const URL_CUSTOMERS_IMAGES_META  = url('/customers/images/metadata');

export const URL_DRIVE_BY_ID            = (folderId: string) => url('/drive/:folderId', { folderId });
export const URL_DRIVE_CLIENT_RECENT    = (clientId: string) => url('/drive/client/:clientId/recent', { clientId });
export const URL_DRIVE_CLIENT_FOLDERS   = (clientId: string) => url('/drive/client/:clientId/folders', { clientId });
export const URL_DRIVE_ITEM_CONTENT     = (itemId: string) => url('/drive/:itemId/content', { itemId });
export const URL_DRIVE_ITEM_FILE        = (itemId: string) => url('/drive/:itemId/file', { itemId });
export const URL_DRIVE_ITEM_DOWNLOAD_ZIP = (itemId: string) => url('/drive/:itemId/download-zip', { itemId });
export const URL_DRIVE_ITEM_RENAME      = (itemId: string) => url('/drive/:itemId/rename', { itemId });
export const URL_DRIVE_ITEM_MOVE        = (itemId: string) => url('/drive/:itemId/move', { itemId });
export const URL_DRIVE_ROOT_FILTERED    = (clientId: string) => `${url('/drive/root/filtered')}?clientId=${clientId}`;
export const URL_DRIVE_FOLDER_FILTERED  = (folderId: string, clientId: string) => `${url('/drive/:folderId/filtered', { folderId })}?clientId=${clientId}`;
// driveId accompanies itemId when drilling into a SHARED folder: its children
// live in the owner's drive, not the caller's.
export const URL_ONEDRIVE_BROWSE        = (itemId?: string, driveId?: string) => {
  if (!itemId) return url('/onedrive/browse');
  const drive = driveId ? `&driveId=${encodeURIComponent(driveId)}` : '';
  return `${url('/onedrive/browse')}?itemId=${encodeURIComponent(itemId)}${drive}`;
};
export const URL_ONEDRIVE_RESOLVE_SHARE = url('/onedrive/resolve-share');
export const URL_ONEDRIVE_LINKS         = url('/onedrive/links');
export const URL_ONEDRIVE_LINKS_FOR     = (clientId: string) => `${url('/onedrive/links')}?clientId=${encodeURIComponent(clientId)}`;
export const URL_ONEDRIVE_LINK_BY_ID    = (driveItemId: string) => url('/onedrive/links/:driveItemId', { driveItemId });
export const URL_ONEDRIVE_LINK_SYNC     = (driveItemId: string) => url('/onedrive/links/:driveItemId/sync', { driveItemId });

export const URL_FOLDER_BY_ID           = (folderId: string) => url('/folder/:folderId', { folderId });
export const URL_FILESHARE_BY_ID        = (fileId: string) => url('/fileshare/:fileId', { fileId });
export const URL_FILESHARE_URL          = (fileId: string) => url('/fileshare/fileUrl/:fileId', { fileId });

export const URL_NOTE_CREATE            = url('/note/create-note');
export const URL_FILE_NOTE_VERSION      = url('/file-note-version');

export const URL_NOTE_BY_ID             = (noteId: string) => url('/note/:noteId', { noteId });
export const URL_NOTE_LIST_BY_CLIENT    = (clientId: string) => url('/note/list/:clientId', { clientId });
export const URL_FILE_NOTE_VERSION_BY_ID = (fileId: string) => url('/file-note-version/:fileId', { fileId });
export const URL_SUMMARY_BY_ID          = (summaryId: string) => url('/summaries/:summaryId', { summaryId });

export const URL_DELETED_ITEMS                      = url('/deleted-items');
export const URL_DELETED_FOLDERS                    = url('/deleted-items/deleted-folders');
export const URL_DELETED_ITEM_RESTORE               = (itemId: string) => url('/deleted-items/:itemId/restore', { itemId });
export const URL_DELETED_ITEM_PERMANENT             = (itemId: string) => url('/deleted-items/:itemId/permanent', { itemId });
export const URL_DELETED_FOLDER_RESTORE             = (folderId: string) => url('/deleted-items/deleted-folders/:folderId/restore', { folderId });
export const URL_DELETED_FOLDER_PERMANENT           = (folderId: string) => url('/deleted-items/deleted-folders/:folderId/permanent', { folderId });

export const URL_ENVELOPES              = url('/envelopes');
export const URL_ENVELOPES_BY_CLIENT    = (clientId: string) => `${url('/envelopes')}?clientId=${clientId}`;
export const URL_ENVELOPES_RECENT_BY_CLIENT = (clientId: string, limit: number) =>
  `${url('/envelopes')}?clientId=${clientId}&limit=${limit}&summary=true`;
export const URL_DOC_TEMPLATE           = url('/doc-template');
export const URL_DOC_TEMPLATE_BY_ORG    = (orgId: string) => `${url('/doc-template')}?orgId=${encodeURIComponent(orgId)}`;
export const URL_DOC_TEMPLATE_CLONE     = url('/doc-template/clone');
export const URL_DOC_TEMPLATE_BUILDER   = url('/doc-template-builder');
export const URL_DOC_TEMPLATE_BUILDER_BY_ORG = (orgId: string) =>
  `${url('/doc-template-builder')}?orgId=${orgId}`;
export const URL_DOC_TEMPLATE_BUILDER_ANALYZE_UPLOAD = url('/doc-template-builder/analyze-upload');
export const URL_DOC_TEMPLATE_BUILDER_MENTIONABLE = url('/doc-template-builder/mentionable');
export const URL_SKILLS_MENTIONABLE = url('/doc-template-builder/skills/mentionable');
export const URL_ADVISOR_RULES_MENTIONABLE = (templateId?: string) =>
  templateId ? `${url('/advisor-rules/mentionable')}?templateId=${encodeURIComponent(templateId)}` : url('/advisor-rules/mentionable');
export const URL_PPT_TEMPLATES          = url('/ppt-templates');
export const URL_PPT_TEMPLATES_UPLOAD   = url('/ppt-templates/upload');
export const URL_PPT_TEMPLATES_DEFAULT_BY_ORG   = (orgId: string) => `${url('/ppt-templates/default')}?orgId=${orgId}`;
export const URL_PPT_TEMPLATE_REFRESH_URL        = (templateId: string) => url('/ppt-templates/refresh-url/:templateId', { templateId });
export const URL_PPT_TEMPLATE_BY_ID     = (templateId: string) => url('/ppt-templates/:templateId', { templateId });
export const URL_PPT_TEMPLATE_SET_DEFAULT = (templateId: string) => url('/ppt-templates/:templateId/set-default', { templateId });
export const URL_AGREEMENTS             = url('/agreements');
export const URL_AGREEMENTS_BY_ORG     = (orgId: string) => `${url('/agreements')}?orgId=${orgId}`;
export const URL_AGREEMENTS_UPLOAD      = url('/agreements/upload');
export const URL_DOCUSEAL_BUILDER_TOKEN = url('/docuseal/builder_token');
export const URL_DOCUSEAL_VOID          = url('/docuseal/void');
export const URL_SUBMISSIONS_EMAILS     = url('/submissions/emails');
export const URL_GENERATE_PRESENTATION  = url('/generate-presentation');
export const URL_PRIVACY_POLICY         = url('/privacy-policy');
export const URL_TERMS_OF_SERVICE       = url('/terms-of-service');

export const URL_ENVELOPE_BY_ID         = (envelopeId: string) => url('/envelopes/:envelopeId', { envelopeId });
export const URL_ENVELOPE_VOID          = (envelopeId: string) => url('/envelopes/:envelopeId/void', { envelopeId });
export const URL_ENVELOPE_SEND          = (envelopeId: string) => url('/envelopes/:envelopeId/send', { envelopeId });
export const URL_ENVELOPE_SAVE_TO_FILES = (envelopeId: string) => url('/envelopes/:envelopeId/save-to-files', { envelopeId });
export const URL_DOC_TEMPLATE_BY_ID     = (templateId: string) => url('/doc-template/:templateId', { templateId });
export const URL_AGREEMENT_BY_ID        = (agreementId: string) => url('/agreements/:agreementId', { agreementId });
export const URL_AGREEMENT_MARK_READY   = (agreementId: string) => url('/agreements/:agreementId/mark-ready', { agreementId });
export const URL_AGREEMENTS_READY       = (orgId: string) => `${url('/agreements/ready-templates')}?orgId=${orgId}`;

export const URL_CHAT                   = url('/chat');
export const URL_CHAT_TOOLS             = url('/chat/tools');
export const URL_CHAT_SUGGESTIONS       = url('/chat/suggestions');
export const URL_CHAT_MESSAGE           = url('/chat/message');
export const URL_CHAT_STATUS            = url('/chat/status');
export const URL_SPEECH_TO_TEXT         = url('/speech-to-text');
export const URL_EMAIL_MAGIC_EDIT       = url('/email/magic-edit');
export const URL_EMAIL_GRAPHRAG         = (clientId: string) => url('/emails/graphrag/:clientId', { clientId });
export const URL_EMAIL_SAVE             = url('/emails/save');

export const URL_CHAT_HISTORY           = (sessionId: string) => url('/chat/history/:sessionId', { sessionId });

export const URL_DCS_CLIENT_CHAT        = (clientId: string) => url('/dcs/customers/:clientId/chat', { clientId });
export const URL_DCS_OBJECTIONS         = (clientId: string) => url('/dcs/objections/:clientId', { clientId });
export const URL_DCS_OBJECTIONS_CHAT    = (clientId: string) => url('/dcs/objections/:clientId/chat', { clientId });
export const URL_DCS_OBJECTIONS_CODE    = url('/dcs/objections/send-code');

export const URL_EMAIL_INBOX_FOLDERS    = url('/email-inbox/folders');
export const URL_EMAIL_INBOX_MESSAGES   = url('/email-inbox/messages');
export const URL_EMAIL_INBOX_CLIENT_MSGS = url('/email-inbox/client-messages');
export const URL_EMAIL_INBOX_CLIENT_DRAFTS = (clientId: string) => `${url('/email-inbox/client-drafts')}?clientId=${encodeURIComponent(clientId)}`;
export const URL_EMAIL_INBOX_DRAFT      = url('/email-inbox/draft');

export const URL_EMAIL_INBOX_MESSAGE    = (messageId: string) => url('/email-inbox/message/:messageId', { messageId });
export const URL_EMAIL_INBOX_READ       = (messageId: string) => url('/email-inbox/read/:messageId', { messageId });
export const URL_EMAIL_INBOX_DRAFT_DEL  = (draftId: string) => url('/email-inbox/draft/:draftId', { draftId });
export const URL_EMAIL_INBOX_FLAG       = (messageId: string) => url('/email-inbox/flag/:messageId', { messageId });
export const URL_EMAIL_INBOX_FORWARD    = (messageId: string) => url('/email-inbox/forward/:messageId', { messageId });
export const URL_EMAIL_INBOX_PERMANENT  = (messageId: string) => url('/email-inbox/permanent/:messageId', { messageId });
export const URL_EMAIL_INBOX_RESTORE    = (messageId: string) => url('/email-inbox/restore/:messageId', { messageId });
export const URL_EMAIL_THREAD_ATTACHMENTS = (messageId: string, attachmentId: string) =>
  url('/email-threading/attachments/:messageId/:attachmentId/preview', { messageId, attachmentId });
export const URL_EMAIL_THREAD_INLINE    = (messageId: string) => url('/email-threading/inline-images/:messageId', { messageId });
export const URL_EMAIL_THREAD           = (conversationId: string) => url('/email-threading/thread/:conversationId', { conversationId });
export const URL_EMAIL_THREAD_REPLY     = url('/email-threading/reply');
export const URL_EMAIL_THREAD_REPLY_ALL = url('/email-threading/reply-all');

export const URL_PROSPO_FACTFIND_EXPORT       = url('/prospo-factfind/export');
export const URL_PROSPO_FACTFIND_UPDATE_GRAPH = url('/prospo-factfind/update-graph');

export const URL_ACTIVITY_CLIENT_SUMMARY = (clientId: string) => url('/activity/client/:clientId/summary', { clientId });

export const URL_FINANCIAL_SUMMARY      = (clientId: string) => url('/financial/financial-summary/:clientId', { clientId });
export const URL_FINANCIAL_LIFE_EVENTS  = (clientId: string) => url('/financial/life-events/:clientId', { clientId });
export const URL_FINANCIAL_RECALCULATE  = (clientId: string) => url('/financial/recalculate/:clientId', { clientId });
export const URL_FACTFIND_ACTIVE        = (clientId: string) => url('/prospo-factfind/active/client/:clientId', { clientId });
export const URL_FACTFIND_BY_CLIENT     = (clientId: string) => url('/prospo-factfind/client/:clientId', { clientId });
export const URL_FACTFIND_HISTORY       = (clientId: string) => url('/prospo-factfind/history/client/:clientId', { clientId });

export const URL_FACTFIND_IMPORT_EXTRACT = (clientId: string) => url('/prospo-factfind/import/extract/client/:clientId', { clientId });
export const URL_FACTFIND_IMPORT_STATUS  = (jobId: string) => url('/prospo-factfind/import/status/:jobId', { jobId });
export const URL_FACTFIND_IMPORT_COMMIT  = (clientId: string) => url('/prospo-factfind/import/commit/client/:clientId', { clientId });
export const URL_FACTFIND_IMPORT_SOURCES = (clientId: string) => url('/prospo-factfind/import/sources/client/:clientId', { clientId });
export const URL_FACTFIND_IMPORT_SOURCE_FILE = (sourceId: string) => url('/prospo-factfind/import/source/:sourceId/file', { sourceId });

export const URL_FACTFIND_ACCESS_RECIPIENTS = (accessId: string) => url('/fact-find/recipients/:accessId', { accessId });
export const URL_FACTFIND_ACCESS_SEND_OTP   = url('/fact-find/send-otp');
export const URL_FACTFIND_ACCESS_VERIFY_OTP = url('/fact-find/verify-otp');

export const URL_USE_GRAPH_SECRET       = url('/use-graph-secret');

export const URL_MODELING_MODULES       = url('/modeling/modules');
export const URL_MODELING_CREATE        = url('/modeling/create-new-module');

export const URL_MODELING_UPDATE        = (moduleId: string) => url('/modeling/:moduleId/update', { moduleId });
export const URL_MODELING_MODULE        = (moduleId: string) => url('/modeling/module/:moduleId', { moduleId });

export const URL_KG_SYNC_CONTACT        = url('/kg/sync-contact');
export const URL_KG_DELETE_CONTACT      = url('/kg/delete-contact');
export const URL_KG_CREATE_CLIENT_GRAPH = url('/kg/create_client_graph');
export const URL_KG_DELETE_CLIENT       = url('/kg/delete-client');
export const URL_KG_CHUNK_EMBEDDING     = url('/kg/chunk_embedding');
export const URL_SEEDING_ONTOLOGY       = url('/seeding/ontology');
export const URL_SEEDING_FACTFIND_ONTOLOGY = url('/seeding/factfind/ontology');
export const URL_ONTOLOGY               = url('/ontology');
export const URL_ONTOLOGY_CLASSES       = url('/ontology/classes');
export const URL_ONTOLOGY_FACTFIND      = url('/ontology/factfind');
export const URL_ONTOLOGY_FACTFIND_FILL_MANUAL = url('/ontology/factfind/fillform/manual');
export const URL_ONTOLOGY_FACTFIND_FILL_MIC    = url('/ontology/factfind/fillform/microphone');
export const URL_ONTOLOGY_FACTFIND_CLIENTGRAPH = (orgId: string, clientId: string) =>
  `${url('/ontology/factfind/clientgraph')}?org_id=${encodeURIComponent(orgId)}&client_id=${encodeURIComponent(clientId)}`;

export const URL_ONTOLOGY_BY_ORG        = (targetOrg: string) => url('/ontology/:targetOrg', { targetOrg });
export const URL_ONTOLOGY_BY_ORG_TYPE   = (orgId: string, type: string) => url('/ontology/:orgId/:type', { orgId, type });
export const URL_GRAPHDB_PREVIEW        = (type: string) => url('/graphdb/:type/preview', { type });

export const URL_CONNECTOR              = url('/connector');
export const URL_CONNECTOR_TOGGLE_EMAIL         = url('/connector/toggle-email-status');
export const URL_CONNECTOR_TOGGLE_AUTO_RECORDING = url('/connector/toggle-auto-recording');
export const URL_CONNECTOR_TOGGLE_OUTLOOK        = url('/connector/toggle-outlook-contacts');
export const URL_CONNECTOR_TOGGLE_STATUS         = url('/connector/toggle-status');
export const URL_CONNECTOR_USER_ZOOM_STATUS      = (userId: string) => url('/connector/user/:userId/zoom/status', { userId });
export const URL_CONNECTOR_USER_ZOOM_DISCONNECT  = (userId: string) => url('/connector/user/:userId/zoom', { userId });
export const URL_CONNECTOR_USER_CALENDLY_DISCONNECT = (userId: string) => url('/connector/user/:userId/calendly', { userId });
export const URL_CONNECTOR_USER_DELETE           = (connectorId: string) => url('/connector/user/:connectorId', { connectorId });
export const URL_MICROSOFT_ORG_DISCONNECT        = url('/microsoft-org/oauth/disconnect');
export const URL_MICROSOFT_ORG_OAUTH_URL         = (redirectUrl: string) =>
  `${url('/microsoft-org/oauth/url')}?frontendRedirectUrl=${encodeURIComponent(redirectUrl)}`;
export const URL_OUTLOOK_CONTACTS_STATUS         = url('/outlook-contacts/status');
export const URL_OUTLOOK_CONTACTS_DISCONNECT     = url('/outlook-contacts/oauth/disconnect');
export const URL_OUTLOOK_CONTACTS                = url('/outlook-contacts/contacts');
export const URL_FIREFLIES_STATUS                = url('/fireflies/status');
export const URL_FIREFLIES_CREDENTIALS           = url('/fireflies/credentials');
export const URL_FIREFLIES_IMPORT                = (meetingId: string) => url('/fireflies/import/:meetingId', { meetingId });
export const URL_FIREFLIES_LIST                  = (qs: string) => `${url('/fireflies/list')}?${qs}`;
export const URL_ADVISER_LOGIC_CREDENTIALS       = url('/adviser-logic/user/credentials');
export const URL_ADVISER_LOGIC_CONTACTS          = url('/adviser-logic/user/contacts');
export const URL_ADVISER_LOGIC_STATUS            = url('/adviser-logic/user/status');
export const URL_INTELLIFLO_CREDENTIALS          = url('/intelliflo/credentials');
export const URL_INTELLIFLO_STATUS               = url('/intelliflo/status');
export const URL_INTELLIFLO_CONTACTS             = url('/intelliflo/contacts');
export const URL_ZOHO_STATUS                     = url('/zoho/status');
export const URL_ZOHO_CONTACTS                   = url('/zoho/contacts');
export const URL_ZOHO_CALLBACK                   = url('/zoho/callback');
export const URL_MONDAY_IMPORT_ALL               = url('/monday/importAll');
export const URL_WORKSORTED_COMPANIES            = url('/worksorted/companies');
export const URL_CORE_LOGIC_AUTH                 = url('/core-logic/get-auth-token');

export const URL_CONNECTOR_BY_ORG       = (orgId: string) => url('/connector/:orgId', { orgId });
export const URL_CONNECTOR_STATUS       = (orgId: string, sourceName: string) =>
  url('/connector/status/:orgId/:sourceName', { orgId, sourceName });
export const URL_CONNECTOR_USER         = (userId: string) => url('/connector/user/:userId', { userId });
export const URL_CONNECTORS             = url('/connectors');
export const URL_CONNECTOR_BY_ID        = (connectorId: string) => url('/connectors/:connectorId', { connectorId });
export const URL_CONNECTOR_SHARING      = (connectorId: string) => url('/connectors/:connectorId/sharing', { connectorId });
export const URL_CONNECTOR_STORAGE_STATS         = (orgId: string) => url('/connectors/:orgId/storage-stats', { orgId });
export const URL_CONNECTOR_SHAREPOINT_DRIVES     = (orgId: string) => url('/connectors/:orgId/sharepoint-drives', { orgId });
export const URL_CONNECTOR_SHAREPOINT_DRIVE_LOC  = (orgId: string) => url('/connectors/:orgId/sharepoint-drive-location', { orgId });
export const URL_CONNECTOR_MIGRATION             = (orgId: string, action: string) => url('/connectors/:orgId/migration/:action', { orgId, action });
export const URL_OUTLOOK_CONTACTS_OAUTH = (redirectUrl: string) =>
  `${url('/outlook-contacts/oauth/url')}?frontendRedirectUrl=${encodeURIComponent(redirectUrl)}`;
export const URL_OUTLOOK_CALENDAR_IMPORT       = url('/meetings/outlook/import');
export const URL_TEAMS_TRANSCRIPTS_AVAILABLE    = (orgId: string, teamsOnlineMeetingId: string, prospoMeetingId: string) =>
  `${url('/teams-transcripts/available/:orgId', { orgId })}?teamsOnlineMeetingId=${encodeURIComponent(teamsOnlineMeetingId)}&prospoMeetingId=${encodeURIComponent(prospoMeetingId)}`;
export const URL_TEAMS_TRANSCRIPTS_IMPORT       = (orgId: string) => url('/teams-transcripts/import/:orgId', { orgId });
export const URL_ZOHO_CONNECT           = (redirectUrl: string) =>
  `${url('/zoho/connect')}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
export const URL_WORKSORTED_CLIENTS     = (companyId: string) =>
  url('/worksorted/companies/:companyId/clients', { companyId });

export const URL_BILLING_CREATE_PORTAL  = url('/billing/create-portal-session');
export const URL_BILLING_CHECKOUT_SEAT  = url('/billing/checkout-per-seat');
export const URL_BILLING_CHECKOUT       = url('/billing/checkout-session');
export const URL_BILLING_INTERVAL       = url('/billing/subscriptions/interval');
export const URL_CREATE_CHECKOUT        = url('/create-checkout-session');
export const URL_CREATE_PAYMENT_INTENT  = url('/create-payment-intent');
export const URL_CREATE_SETUP_INTENT    = url('/create-setup-intent');
export const URL_SAVE_PAYMENT_DETAILS   = url('/save-payment-details');

export const URL_BILLING_SUBSCRIPTION   = (orgId: string) => url('/billing/subscriptions/:orgId', { orgId });
export const URL_BILLING_PER_SEAT_INFO  = (orgId: string) => `${url('/billing/per-seat-info')}?orgId=${encodeURIComponent(orgId)}`;
export const URL_BILLING_PRORATION_PREVIEW = (orgId: string, newPriceId: string) =>
  `${url('/billing/subscriptions/proration-preview')}?orgId=${encodeURIComponent(orgId)}&newPriceId=${encodeURIComponent(newPriceId)}`;

export const URL_DASHBOARD_SESSION_STATS      = url('/dashboard/session-stats');
export const URL_DASHBOARD_REAL_TIME_METRICS  = url('/dashboard/real-time-metrics');
export const URL_DASHBOARD_LOGINS_SUMMARY     = url('/dashboard/logins-summary');
export const URL_DASHBOARD_FEATURE_USAGE      = url('/dashboard/feature-usage-stats');
export const URL_DASHBOARD_CLIENT_ADVISOR     = url('/dashboard/client-advisor-stats');
export const URL_DASHBOARD_USER_ACTIVITY_DETAILS = url('/dashboard/user-activity-details');
export const URL_DASHBOARD_USER_SESSION_DETAILS  = (userId: string) => url('/dashboard/user-session-details/:userId', { userId });
export const URL_DASHBOARD_EXPERIMENTAL_FEATURE_USAGE = url('/dashboard/experimental-feature-usage-stats');
export const URL_DASHBOARD_AGENT_USAGE          = url('/dashboard/agent-usage-stats');
export const URL_DASHBOARD_TOP_QUESTIONS_ASKED  = url('/dashboard/top-questions-asked');
export const URL_DASHBOARD_AGENT_TOOL_DETAIL     = url('/dashboard/agent-usage/tool-detail');
export const URL_DASHBOARD_AGENT_USER_DETAIL     = url('/dashboard/agent-usage/user-detail');
export const URL_DASHBOARD_AGENT_QUESTION_DETAIL = url('/dashboard/agent-usage/question-detail');

export const URL_LOGS                   = url('/logs');
export const URL_CHECK_API_STATUS       = (api: string) => `${url('/checkapistatus')}?api=${encodeURIComponent(api)}`;

export const URL_TEST_SUITES_RUN        = url('/test-suites/run');
export const URL_TEST_SUITES_RUN_SUITE  = url('/test-suites/run-suite');
export const URL_TEST_SUITES_COLLECT    = url('/test-suites/collect');
export const URL_TEST_SUITE_RUN_BY_ID   = (runId: string) => url('/test-suites/runs/:runId', { runId });
export const URL_TEST_SUITES_LATEST_PER_PATTERN = url('/test-suites/latest-per-pattern');
export const URL_TEST_SUITES_RUNS       = (page: number, limit: number) =>
  `${url('/test-suites/runs')}?page=${page}&limit=${limit}`;
export const URL_TEST_SUITES_RUN_ALL    = url('/test-suites/run-all');
export const URL_TEST_SUITES_CANCEL_RUN = (runId: string) => url('/test-suites/runs/:runId/cancel', { runId });

export const URL_REGRESSION_RUNS_LIST   = (page: number, limit: number) =>
  `${url('/regression-runs')}?page=${page}&limit=${limit}`;
export const URL_REGRESSION_RUN_LATEST      = url('/regression-runs/latest');
export const URL_REGRESSION_RUN_HISTORY_BAR = (n: number) => `${url('/regression-runs/history-bar')}?n=${n}`;
export const URL_REGRESSION_RUN_BY_ID   = (id: string) => url('/regression-runs/:id', { id });

export const URL_WORKFLOW_CLIENT_JOURNEY = url('/workflow/client-journey');
export const URL_WORKFLOW_ACTION_TYPES   = url('/workflow/action-types');

export const URL_WIKI_PAGE_VISIBILITY    = (id: string) => url('/wiki/:id/visibility', { id });
export const URL_WIKI_PAGE_PERMISSIONS   = (id: string) => url('/wiki/:id/permissions', { id });
export const URL_WIKI_PAGE_DRAFT = (id: string) => `${URL_WIKI_PAGES}/${id}/draft`;
export const URL_WIKI_PAGE_SUMMARIZE  = (id: string) => `${URL_WIKI_PAGES}/${id}/summarize`;
export const URL_WIKI_FOLDERS         = `${URL_WIKI_PAGES}/folders`;
export const URL_WIKI_PAGE_MOVE       = (id: string) => `${URL_WIKI_PAGES}/${id}/move`;
export const URL_WIKI_PAGE_PERMISSION    = (id: string, userId: string) =>
  url('/wiki/:id/permissions/:userId', { id, userId });
export const URL_WIKI_PAGE_NOTIFY_ALL = (id: string) => `${URL_WIKI_PAGES}/${id}/notify-all`;

export const URL_WIKI_NOTIFICATIONS              = url('/wiki-notifications');
export const URL_WIKI_NOTIFICATIONS_UNREAD_COUNT = url('/wiki-notifications/unread-count');
export const URL_WIKI_NOTIFICATIONS_READ_ALL     = url('/wiki-notifications/read-all');
export const URL_WIKI_NOTIFICATION_READ          = (id: string) => url('/wiki-notifications/:id/read', { id });
export const URL_WIKI_NOTIFICATION_DELETE        = (id: string) => url('/wiki-notifications/:id', { id });

export const URL_WIKI_PAGE_COMMENTS    = (id: string) => `${URL_WIKI_PAGES}/${id}/comments`;
export const URL_WIKI_COMMENT_BY_ID    = (pageId: string, commentId: string) =>
  `${URL_WIKI_PAGES}/${pageId}/comments/${commentId}`;
export const URL_WIKI_COMMENT_RESOLVE  = (pageId: string, commentId: string) =>
  `${URL_WIKI_PAGES}/${pageId}/comments/${commentId}/resolve`;
export const URL_WIKI_PAGE_VERSIONS    = (id: string) => `${URL_WIKI_PAGES}/${id}/versions`;
export const URL_WIKI_PAGE_VERSION     = (id: string, versionId: string) =>
  `${URL_WIKI_PAGES}/${id}/versions/${versionId}`;

export const URL_IMAGES_FILTERED_RAW    = url('/images/get-filtered-raw-images');
export const URL_IMAGES_STATS           = url('/images/image-stats');
export const URL_IMAGES_L2_COUNTS       = url('/images/l2-counts');
export const URL_IMAGE_LABEL            = (imageId: string) => url('/images/label/:imageId', { imageId });
export const URL_IMAGE_DELETE_BOX       = (imageId: string) => url('/images/delete-box/:imageId', { imageId });
export const URL_IMAGE_MARK_COMPLETED   = (imageId: string) => url('/images/mark-completed/:imageId', { imageId });

export const URL_SMS_HISTORY            = (clientId: string) => url('/sms/history/client/:clientId', { clientId });
export const URL_SMS_SEND               = url('/sms/send');
export const URL_PRODUCT_FEEDBACK       = url('/product-feedback');
export const URL_PRODUCT_FEEDBACK_ME    = (page: number, limit: number) =>
  `${url('/product-feedback/me')}?page=${page}&limit=${limit}`;
export const URL_PRODUCT_FEEDBACK_BY_ID = (id: string) => url('/product-feedback/:id', { id });
export const URL_PRODUCT_FEEDBACK_SOLVE = (id: string) => url('/product-feedback/:id/solve', { id });
export const URL_PYTHON_GRAPH_DATA      = url('/python-proxy/get_graph_data/');
export const URL_PYTHON_COMMS_AGENT     = url('/python-proxy/commsagent');


// ---------------------------------------------------------------------------
// Release Notes (Global Admin authoring + end-user modal)
// ---------------------------------------------------------------------------

export const URL_RELEASE_NOTES            = url('/release-notes');
export const URL_RELEASE_NOTES_LIST       = (page: number, limit: number, status?: string) =>
  `${url('/release-notes')}?page=${page}&limit=${limit}${status ? `&status=${status}` : ''}`;
export const URL_RELEASE_NOTE_BY_ID       = (id: string) => url('/release-notes/:id', { id });
export const URL_RELEASE_NOTE_PUBLISH     = (id: string) => url('/release-notes/:id/publish', { id });
export const URL_RELEASE_NOTE_RESEND      = (id: string) => url('/release-notes/:id/resend', { id });
export const URL_RELEASE_NOTE_DISMISS     = (id: string) => url('/release-notes/:id/dismiss', { id });
export const URL_RELEASE_NOTES_PENDING    = url('/release-notes/pending');
export const URL_RELEASE_NOTES_AUDIENCE   = url('/release-notes/preview-audience');
export const URL_RELEASE_NOTE_IMAGES      = url('/release-notes/images');


// ---------------------------------------------------------------------------
// ABR (Australian Business Register) — shared ABN lookup / name search
// ---------------------------------------------------------------------------

export const URL_ABR                       = (abn: string) => url('/abr/:abn', { abn });
export const URL_ABR_SEARCH                = (name: string) =>
  `${url('/abr/search')}?name=${encodeURIComponent(name)}`;

export const URL_REVENUE_STATEMENTS        = url('/revenue/statements');
export const URL_REVENUE_STATEMENT_BY_ID   = (id: string) => url('/revenue/statements/:id', { id });
export const URL_REVENUE_STATEMENT_REPARSE = (id: string) => url('/revenue/statements/:id/reparse', { id });
export const URL_REVENUE_STATEMENT_FILE    = (id: string) => url('/revenue/statements/:id/file', { id });
export const URL_REVENUE_STATEMENT_CREATE_CLIENTS = (id: string) =>
  url('/revenue/statements/:id/create-clients', { id });
export const URL_REVENUE_SUMMARY           = (fy?: string, types?: string[]) => {
  const params = new URLSearchParams();
  if (fy) params.set('fy', fy);
  if (types?.length) params.set('types', types.join(','));
  const qs = params.toString();
  return `${url('/revenue/summary')}${qs ? `?${qs}` : ''}`;
};
export const URL_REVENUE_ABR               = (abn: string) => url('/revenue/abr/:abn', { abn });
export const URL_REVENUE_ABR_SEARCH        = (name: string) =>
  `${url('/revenue/abr-search')}?name=${encodeURIComponent(name)}`;
export const URL_REVENUE_STATEMENT_COLUMNS = (id: string) =>
  url('/revenue/statements/:id/columns', { id });
export const URL_REVENUE_STATEMENT_APPLY_MAPPING = (id: string) =>
  url('/revenue/statements/:id/apply-mapping', { id });
export const URL_REVENUE_COLUMN_MAPPINGS   = url('/revenue/column-mappings');
export const URL_REVENUE_COLUMN_MAPPING_BY_ID = (id: string) =>
  url('/revenue/column-mappings/:id', { id });

export const URL_EXPENSE_INVOICES          = url('/expenses/invoices');
export const URL_EXPENSE_INVOICE_BY_ID     = (id: string) => url('/expenses/invoices/:id', { id });
export const URL_EXPENSE_INVOICE_REPARSE   = (id: string) => url('/expenses/invoices/:id/reparse', { id });
export const URL_EXPENSE_INVOICE_FILE      = (id: string) => url('/expenses/invoices/:id/file', { id });
export const URL_EXPENSE_INVOICE_CREATE_CLIENT = (id: string) =>
  url('/expenses/invoices/:id/create-client', { id });
export const URL_EXPENSE_SUMMARY           = (fy?: string) =>
  `${url('/expenses/summary')}${fy ? `?fy=${encodeURIComponent(fy)}` : ''}`;
export const URL_EXPENSE_ABR               = (abn: string) => url('/expenses/abr/:abn', { abn });
export const URL_EXPENSE_ABR_SEARCH        = (name: string) =>
  `${url('/expenses/abr-search')}?name=${encodeURIComponent(name)}`;

// ---------------------------------------------------------------------------
// Workflows (automation canvas)
// ---------------------------------------------------------------------------

export const URL_WORKFLOWS                 = url('/workflows');
export const URL_WORKFLOWS_TOOLS           = url('/workflows/tools');
export const URL_WORKFLOWS_GENERATE        = url('/workflows/generate');
export const URL_WORKFLOW_BY_ID            = (id: string) => url('/workflows/:id', { id });
export const URL_WORKFLOW_DUPLICATE        = (id: string) => url('/workflows/:id/duplicate', { id });
export const URL_WORKFLOW_ACTIVATE         = (id: string) => url('/workflows/:id/activate', { id });
export const URL_WORKFLOW_DEACTIVATE       = (id: string) => url('/workflows/:id/deactivate', { id });
export const URL_WORKFLOW_RUN              = (id: string) => url('/workflows/:id/run', { id });
export const URL_WORKFLOW_RUNS             = (id: string) => url('/workflows/:id/runs', { id });
export const URL_WORKFLOW_RUN_BY_ID        = (runId: string) => url('/workflows/runs/:runId', { runId });
export const URL_WORKFLOW_RUN_STOP         = (runId: string) => url('/workflows/runs/:runId/stop', { runId });
export const URL_WORKFLOW_RUN_RESUME       = (runId: string) => url('/workflows/runs/:runId/resume', { runId });
